import React from 'react';

const Services = () => {

    return (
        <div id="services" className="bg-gradient-to-br from-gray-50 to-blue-50 py-16 md:py-24">
            {/* 服务卡片区域 */}
            <section>
                <div className="container mx-auto px-4 md:px-8">
                    {/* 标题区域 */}
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                            {/* 使用星星emoji替代SVG */}
                            <span className="text-2xl">⭐</span>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">发展规划</h2>
                        <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                            以“族语APP”为起点，构建全链路数字化亲情传承生态体系
                        </p>
                    </div>

                    {/* 战略卡片网格 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* 产品战略 */}
                        <div className="group relative bg-gradient-to-br from-white to-green-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border border-green-100">
                            <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <div className="p-7 relative">
                                {/* 图标部分 */}
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                                        <span className="text-2xl text-white">🎯</span>
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-emerald-700 bg-clip-text text-transparent">智能家谱</h3>
                                        <p className="text-sm text-gray-500 mt-1">构建家族矩阵</p>
                                    </div>
                                </div>

                                {/* 核心概念 */}
                                <div className="mb-5">
                                    <div className="inline-block bg-green-100 text-green-700 text-sm font-medium px-3 py-1 rounded-full mb-3">
                                        核心功能
                                    </div>
                                    <p className="text-lg font-semibold text-gray-800 leading-tight">
                                        以信任为核心，多重验证确保<span className="text-green-600">隐私安全</span>
                                    </p>
                                </div>

                                {/* 具体内容 */}
                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            极简操作，<span className="font-semibold text-green-700">家人共创</span>
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            安全私密，<span className="font-semibold text-green-700">真实可信</span>
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            共建同创，<span className="font-semibold text-green-700">一键同步</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 to-emerald-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                        </div>

                        {/* 品牌战略 */}
                        <div className="group relative bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border border-blue-100">
                            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-indigo-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <div className="p-7 relative">
                                {/* 图标部分 */}
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                                        <span className="text-2xl text-white">🌟</span>
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent">成长动态</h3>
                                        <p className="text-sm text-gray-500 mt-1">记录孩子的成长</p>
                                    </div>
                                </div>

                                {/* 核心概念 */}
                                <div className="mb-5">
                                    <div className="inline-block bg-blue-100 text-blue-700 text-sm font-medium px-3 py-1 rounded-full mb-3">
                                        产品优势
                                    </div>
                                    <p className="text-lg font-semibold text-gray-800 leading-tight">
                                        现在记录的童年，是孩子完整的人生
                                    </p>
                                </div>

                                {/* 具体内容 */}
                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            记录成长动态，家人<span className="font-semibold text-blue-700">实时共览</span>
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            孩子长大后，认证即可<span className="font-semibold text-blue-700">自动继承账号</span>
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            动态时间自定义，还原成长轨迹
                                        </p>
                                    </div>
                                </div>
                            </div>


                            {/* 悬停效果装饰 */}
                            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-indigo-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                        </div>

                        {/* 科技赋能 */}
                        <div className="group relative bg-gradient-to-br from-white to-purple-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border border-purple-100">
                            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-pink-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <div className="p-7 relative">
                                {/* 图标部分 */}
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                                        <span className="text-2xl text-white">🚀</span>
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-700 bg-clip-text text-transparent">日常动态</h3>
                                        <p className="text-sm text-gray-500 mt-1">记录自己的人生</p>
                                    </div>
                                </div>

                                {/* 核心概念 */}
                                <div className="mb-5">
                                    <div className="inline-block bg-purple-100 text-purple-700 text-sm font-medium px-3 py-1 rounded-full mb-3">
                                        功能场景
                                    </div>
                                    <p className="text-lg font-semibold text-gray-800 leading-tight">
                                        每天的日常，都是自己的人生
                                    </p>
                                </div>

                                {/* 具体内容 */}
                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-purple-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            当下记录的动态，是未来怀念的过去
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-purple-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            让亲人后辈，更了解我们的故事
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-purple-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            记录人生故事，完善人生旅程
                                        </p>
                                    </div>
                                </div>
                            </div>


                            {/* 悬停效果装饰 */}
                            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-purple-400 to-pink-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                        </div>

                        {/* 人生传记 */}
                        <div className="group relative bg-gradient-to-br from-white to-orange-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border border-orange-100">
                            <div className="absolute inset-0 bg-gradient-to-br from-orange-500/5 to-amber-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <div className="p-7 relative">
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-amber-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                                        <span className="text-2xl text-white">📖</span>
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-amber-700 bg-clip-text text-transparent">人生传记</h3>
                                        <p className="text-sm text-gray-500 mt-1">共创亲人记忆</p>
                                    </div>
                                </div>

                                <div className="mb-5">
                                    <div className="inline-block bg-orange-100 text-orange-700 text-sm font-medium px-3 py-1 rounded-full mb-3">
                                        亲情传承
                                    </div>
                                    <p className="text-lg font-semibold text-gray-800 leading-tight">
                                        不要让爱，成为遗憾
                                    </p>
                                </div>

                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            回忆模糊的过去，追思逝去的家人
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            让长辈的故事，历久弥新
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            普通人也值得被后辈铭记
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-orange-400 to-amber-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                        </div>

                        {/* 时光私信 */}
                        <div className="group relative bg-gradient-to-br from-white to-teal-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border border-teal-100">
                            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/5 to-cyan-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <div className="p-7 relative">
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                                        <span className="text-2xl text-white">✉️</span>
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-cyan-700 bg-clip-text text-transparent">时光私信</h3>
                                        <p className="text-sm text-gray-500 mt-1">发给未来的消息</p>
                                    </div>
                                </div>

                                <div className="mb-5">
                                    <div className="inline-block bg-teal-100 text-teal-700 text-sm font-medium px-3 py-1 rounded-full mb-3">
                                        使用场景
                                    </div>
                                    <p className="text-lg font-semibold text-gray-800 leading-tight">
                                        穿越时间，对话未来
                                    </p>
                                </div>

                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-teal-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            与未来的亲人对话
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-teal-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            与同龄的孩子交流
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-teal-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            为家人留下每一个重要时刻的祝福
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-teal-400 to-cyan-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                        </div>

                        {/* 祈愿祝福 */}
                        <div className="group relative bg-gradient-to-br from-white to-rose-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border border-rose-100">
                            <div className="absolute inset-0 bg-gradient-to-br from-rose-500/5 to-red-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <div className="p-7 relative">
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="w-14 h-14 bg-gradient-to-br from-rose-500 to-red-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md">
                                        <span className="text-2xl text-white">🙏</span>
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold bg-gradient-to-r from-rose-600 to-red-700 bg-clip-text text-transparent">祈愿祝福</h3>
                                        <p className="text-sm text-gray-500 mt-1">许下自己的愿望</p>
                                    </div>
                                </div>

                                <div className="mb-5">
                                    <div className="inline-block bg-rose-100 text-rose-700 text-sm font-medium px-3 py-1 rounded-full mb-3">
                                        功能说明
                                    </div>
                                    <p className="text-lg font-semibold text-gray-800 leading-tight">
                                        为自己许愿，给家人祈福
                                    </p>
                                </div>

                                <div className="space-y-3">
                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-rose-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            一念祈愿，岁岁平安
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-rose-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            心藏期许，静候如愿
                                        </p>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <div className="w-2 h-2 bg-rose-400 rounded-full mt-2 flex-shrink-0"></div>
                                        <p className="text-gray-700 leading-relaxed">
                                            祈家人安康无恙，愿亲人喜乐常伴
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-rose-400 to-red-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default Services;